import { createSlotRecipe } from './runtime.js';

const pwaTitleBarConfig = {"name":"pwaTitleBar","slots":["root","slot","center","content"],"variantMap":{"position":["left","right"]}}

export const pwaTitleBar = /* @__PURE__ */ createSlotRecipe(pwaTitleBarConfig)